import { BoltApiClient } from "@bolt/core";
import { IBoltComment } from "../../types/IBoltComment";
import { INewBoltComment } from "../../types/INewBoltComment";
import { BoltUserCommentExpressionSchema } from "../../types/BoltUserCommentExpressionSchema";

export class BoltCommentsApiClient {
  constructor(private readonly boltApiClient: BoltApiClient) {}

  // Get comment by ID
  async getCommentById(id: string): Promise<IBoltComment> {
    return this.boltApiClient.get<IBoltComment>(`comments/${id}`);
  }

  // Get comments for an entity
  async getComments(
    entityType: string,
    entityId: string
  ): Promise<IBoltComment[]> {
    return this.boltApiClient.get<IBoltComment[]>(
      `comments/${entityType}/${entityId}`
    );
  }

  // Create a new comment
  async createComment(comment: INewBoltComment): Promise<IBoltComment> {
    return this.boltApiClient.post<IBoltComment>("comments", comment);
  }

  // Update an existing comment
  async updateComment(
    id: string,
    comment: BoltUserCommentExpressionSchema
  ): Promise<IBoltComment> {
    return this.boltApiClient.put<IBoltComment>(`comments/${id}`, comment);
  }

  // Delete a comment
  async deleteComment(id: string): Promise<void> {
    return this.boltApiClient.delete(`comments/${id}`);
  }
}

export const createBoltCommentsApiClient = (boltApiClient: BoltApiClient) => {
  return new BoltCommentsApiClient(boltApiClient);
};
